import Contracts from "../../components/Contracts/Contracts";
import Section from "../../components/UI/Section/Section";
import ProfileTabs from "../../components/User/ProfileTabs";
import UserPanel from "../../components/User/UserPanel";

export default () => {

  return (
    <>
      <UserPanel/>
      <Section>
        <ProfileTabs/>
      </Section>
      <Contracts type="personal"/>
      
    </>
  );
}
